/* View in your room, camera overlay (no 3D model). See snippets/ar-camera.liquid. */
(function () {
  'use strict';
  var PX_PER_IN = 14; // starting scale: a 12 in tile is about 168 px on screen, then the shopper resizes

  function init(wrap) {
    var openBtn = wrap.querySelector('[data-ar-camera-open]');
    var arc = wrap.querySelector('[data-arc]');
    if (!openBtn || !arc) return;
    var video = arc.querySelector('[data-arc-video]');
    var stage = arc.querySelector('[data-arc-stage]');
    var patch = arc.querySelector('[data-arc-patch]');
    var msg = arc.querySelector('[data-arc-msg]');
    var size = arc.querySelector('[data-arc-size]');
    var tilt = arc.querySelector('[data-arc-tilt]');
    var rot = arc.querySelector('[data-arc-rot]');
    var op = arc.querySelector('[data-arc-op]');
    var tw = parseFloat(arc.dataset.tileW) || 12;
    var tl = parseFloat(arc.dataset.tileL) || tw;
    var stream = null, facing = 'environment';
    var x = 0, y = 120, pinchStart = 0, sizeStart = 100;
    var pointers = {};
    var horizon = arc.querySelector('[data-arc-horizon]');
    var hint = arc.querySelector('[data-arc-hint]');
    var hy = 0.42, hl = 0, hr = 1, rotStart = 0, angStart = 0;
    var edges = { l: arc.querySelector('[data-arc-edge="l"]'), r: arc.querySelector('[data-arc-edge="r"]') };
    function setHorizon() {
      var h = arc.clientHeight * hy, w = arc.clientWidth;
      horizon.style.top = h + 'px';
      stage.style.clipPath = 'inset(' + h + 'px ' + (w * (1 - hr)) + 'px 0 ' + (w * hl) + 'px)';
      if (edges.l) { edges.l.style.left = (w * hl) + 'px'; edges.l.style.top = h + 'px'; }
      if (edges.r) { edges.r.style.left = (w * hr) + 'px'; edges.r.style.top = h + 'px'; }
    }
    function dismissHint() { hint.classList.add('is-gone'); }
    function reset() {
      x = 0; y = 120; size.value = 100; tilt.value = 55; rot.value = 0; op.value = 88; hy = 0.42; hl = 0; hr = 1; setHorizon(); apply();
    }
    arc.querySelector('[data-arc-more]').addEventListener('click', function (e) {
      var o = arc.classList.toggle('is-more'); e.currentTarget.setAttribute('aria-expanded', o); e.currentTarget.textContent = o ? 'Less' : 'More';
    });
    arc.querySelector('[data-arc-reset]').addEventListener('click', reset);
    horizon.addEventListener('pointerdown', function (e) { horizon.setPointerCapture(e.pointerId); dismissHint(); e.stopPropagation(); });
    horizon.addEventListener('pointermove', function (e) {
      if (!horizon.hasPointerCapture(e.pointerId)) return;
      hy = Math.max(0.1, Math.min(0.85, e.clientY / arc.clientHeight)); setHorizon();
    });
    ['l', 'r'].forEach(function (side) {
      var el = edges[side]; if (!el) return;
      el.addEventListener('pointerdown', function (e) { el.setPointerCapture(e.pointerId); dismissHint(); e.stopPropagation(); });
      el.addEventListener('pointermove', function (e) {
        if (!el.hasPointerCapture(e.pointerId)) return;
        var fx = Math.max(0, Math.min(1, e.clientX / arc.clientWidth));
        if (side === 'l') hl = Math.min(fx, hr - 0.15); else hr = Math.max(fx, hl + 0.15);
        setHorizon();
      });
    });
    window.addEventListener('resize', setHorizon);

    patch.style.backgroundImage = 'url("' + arc.dataset.texture + '")';

    function apply() {
      var s = size.value / 100;
      patch.style.backgroundSize = (tw * PX_PER_IN * s) + 'px ' + (tl * PX_PER_IN * s) + 'px';
      patch.style.transform = 'translate(' + x + 'px,' + y + 'px) rotateX(' + tilt.value + 'deg) rotateZ(' + rot.value + 'deg)';
      patch.style.opacity = op.value / 100;
    }
    function say(t) { if (t) { msg.textContent = t; msg.hidden = false; } else { msg.hidden = true; } }

    function startCamera() {
      say('');
      if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; }
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        say('Your browser cannot open the camera here. Open this page on your phone.');
        return;
      }
      navigator.mediaDevices.getUserMedia({ video: { facingMode: facing }, audio: false }).then(function (s) {
        stream = s; video.srcObject = s; video.play && video.play();
      }).catch(function () {
        say('We could not open the camera. Allow camera access for this site and try again.');
      });
    }
    function open() {
      arc.hidden = false; document.body.style.overflow = 'hidden';
      setHorizon(); apply(); startCamera();
      hint.classList.remove('is-gone'); setTimeout(dismissHint, 7000);
    }
    function close() {
      arc.hidden = true; document.body.style.overflow = '';
      if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; }
      video.srcObject = null;
    }

    openBtn.addEventListener('click', open);
    arc.querySelector('[data-arc-close]').addEventListener('click', close);
    arc.querySelector('[data-arc-flip]').addEventListener('click', function () {
      facing = facing === 'environment' ? 'user' : 'environment'; startCamera();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !arc.hidden) close(); });
    [size, tilt, rot, op].forEach(function (el) { el.addEventListener('input', apply); });

    // drag to move, two fingers to resize
    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinchStart = Math.hypot(a.x - b.x, a.y - b.y); sizeStart = parseFloat(size.value);
        angStart = Math.atan2(b.y - a.y, b.x - a.x); rotStart = parseFloat(rot.value);
      }
    });
    stage.addEventListener('pointermove', function (e) {
      var p = pointers[e.pointerId]; if (!p) return;
      var ids = Object.keys(pointers);
      if (ids.length === 1) { x += e.clientX - p.x; y += e.clientY - p.y; }
      p.x = e.clientX; p.y = e.clientY;
      if (ids.length === 2 && pinchStart) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        size.value = Math.max(30, Math.min(400, sizeStart * d / pinchStart));
        var ang = Math.atan2(b.y - a.y, b.x - a.x);
        rot.value = Math.max(-90, Math.min(90, rotStart + (ang - angStart) * 180 / Math.PI));
      }
      dismissHint();
      apply();
    });
    function up(e) { delete pointers[e.pointerId]; pinchStart = 0; }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    stage.addEventListener('wheel', function (e) {
      e.preventDefault(); size.value = Math.max(30, Math.min(400, parseFloat(size.value) - e.deltaY * 0.2)); apply();
    }, { passive: false });
  }

  function boot() { document.querySelectorAll('[data-ar-camera-wrap]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
